import React, { useState, useEffect } from "react";
import { ContentTable } from "./ContentTable";
import { formatNumber, formatCurrency } from "utils/currencyFormat";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";

export const TableDanhSach = ({
  listDataDanhSach,
  dataSearch,
  setDataSearch,
  onSearch,
  isQRThanhToan,
  setDisableXacNhan,
}) => {

  useEffect(() => {
    // dispatch(getListNhanVay(dataSearch));
  }, []);


  const [isModalQRVisible, setModalQRVisible] = useState(false);
  const [soTien, setSoTien] = useState(0);
  const [dataShowQR, setDataShowQR] = useState({});
  const toggleModalQR = (item, SoTien) => {
    setSoTien(SoTien);
    setDataShowQR(item);
    setModalQRVisible(!isModalQRVisible);
  };
  return (
    <>
      <div className="card border-light mb-1 card-v2">
        <div className="Left808x200 Table-main-new">
          <div className="loading-page1">
            <div
            // className={
            //   "loader loader-default " +
            //   (listDataDanhSach.getListNhanVayLoading ? "is-active" : "")
            // }
            ></div>
          </div>
          <div className={"table-mobile sticky-table-bh2 table-mobile-hover"}>
            <div className="custom-table-wrapper">
              <div className="table-headers">
                <div className="custom-table-header flex-basis-4 flex-basis-6-sm">
                  <p className="text-center">
                    STT
                    <br />{" "}
                    <span className="red">[ {listDataDanhSach.iTotal} ]</span>
                  </p>
                </div>
                <div className="custom-table-header flex-basis-9 flex-basis-15-6-sm">
                  <p>Mã hợp đồng</p>
                </div>
                <div className="custom-table-header flex-basis-9 flex-basis-11-8-sm">
                  <p>Tên khách hàng</p>
                </div>
                <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                  <p className="text-right">
                    Số tiền vay
                    <br />
                    <PopoversBootrap
                      contentText={formatNumber(listDataDanhSach.TotalValue4)}
                      trigger={["hover", "focus"]}
                      placement={"bottom"}
                    >
                      <span className="color-do-bold">
                        {formatCurrency(listDataDanhSach.TotalValue4)}
                      </span>
                    </PopoversBootrap>
                  </p>
                </div>
                <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                  <p className="text-right">
                    Tổng nợ
                    <br />
                    <PopoversBootrap
                      contentText={formatNumber(listDataDanhSach.TotalValue2)}
                      trigger={["hover", "focus"]}
                      placement={"bottom"}
                    >
                      <span className="color-do-bold">
                        {formatCurrency(listDataDanhSach.TotalValue2)}
                      </span>
                    </PopoversBootrap>
                  </p>
                </div>
                <div className="custom-table-header flex-basis-15 flex-basis-13-sm">
                  <p className="text-left">Lý do</p>
                </div>
                <div className="custom-table-header flex-basis-30 flex-basis-13-sm">
                  <p className="text-center">Đóng tiền nhanh</p>
                </div>
                <div className="custom-table-header flex-basis-10 flex-basis-13-sm">
                  <p className="text-center">Trạng thái</p>
                </div>
              </div>

              <div className="custom-table-body">
                <ContentTable
                  listData={listDataDanhSach.List}
                  onSearch={onSearch}
                  setDataSearch={setDataSearch}
                  dataSearch={dataSearch}
                  toggleModalQR={toggleModalQR}
                  isQRThanhToan={isQRThanhToan}
                  setDisableXacNhan={setDisableXacNhan}
                />
              </div>
              {isModalQRVisible && (
                <ModelQRThanhToanHD
                  show={isModalQRVisible}
                  onHide={toggleModalQR}
                  hopdong={dataShowQR}
                  SoTien={soTien}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
